module.exports = __webpack_public_path__ + "static/img/null-7.42c8c194.png";